
import { defineComponent } from 'vue';
import ScheduleTemplate from '@/components/templates/program/ScheduleTemplate.vue';
import { useI18n } from '@/plugins/i18n';
import JaMessages from '@/assets/i18n/ja/program/schedule.json';
import EnMessages from '@/assets/i18n/en/program/schedule.json';

export default defineComponent({
  name: 'Schedule',
  components: { ScheduleTemplate },
  setup() {
    const i18n = useI18n();
    i18n.$setMessages(JaMessages, EnMessages);

    return {
      i18n,
    };
  },
});
